
import { Component, Vue } from 'vue-property-decorator'
import qs from 'qs'

import Viewport from '@/components/Viewport.vue'
import ActionButtons from '@/components/ActionButtons.vue'

@Component({
  components: {
    Viewport,
    ActionButtons
  }
})
export default class App extends Vue {
  query: {
    model?: string,
    brand?: string,
    mode?: string
  } = {}

  loaded = false
  failed = false
  loaderType = 'default'
  mode = 'default'

  mounted () {
    this.query = qs.parse(location.search.slice(1), { comma: true })
    if (this.query.brand === 'dodo') {
      this.loaderType = 'dodo'
    }
    if (this.query.mode != null) {
      this.mode = this.query.mode
    }
  }
}
